enum FlowType {
  WEB_TENDER = 'WEB_TENDER',
  APPOINTMENT = 'APPOINTMENT',
}

export default FlowType;
